import moment from "moment-timezone"
import trash from './svg/trash.svg'
import {timeFormat} from '../../utilities'

export const prettyStatus = item => {
  switch(item.status) {
    case 'blackout_conflict':
      return 'there is a blackout in effect';

    case 'open_conflict':
      return 'the shop is not open at this time';

    case 'schedule_conflict':
      return `it is not scheduled at this time`;

    case 'booking_conflict':
      return `it is already fully booked at that time`;

    case 'ok':
      return `success`;

    default:
      const past = item.status.match(/can't be in the past/)
      return past ? `can't be in the past` : item.status
  }
}

export const prettyTitle = item => {
  const variantTitle = item.variant_title === 'Default Title' ? '' : ` / <span class="reservation-variant-title">${item.variant_title}</span>`
  return `<span class="reservation-product-title">${item.product_title}</span>${variantTitle}`
}

export const prettyTime = (message, tz) => {
  const utcDates = message.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/g)
  utcDates && utcDates.forEach(date => {
    message = message.replace(date, moment.tz(date, tz).format('LLL (z)'))
  })
  return message
}

export const prettyMessage = data => {
  const message = item => {
    if ([
      'blackout_conflict',
      'open_conflict',
      'schedule_conflict',
      'booking_conflict',
      'past_conflict'
    ].includes(item.status)) {
      return (`<time class="data-date" datetime="${item.start}">
                ${moment.tz(item.start, data.tz).format(itemDateTimeFormat(item.all_day || false))}
              </time>  
              ${prettyTitle(item)} could not be reserved because ${prettyStatus(item)}.`)
    } else {
      return item.status
    }
  }

  return (`
          <p class="reservation-warning">Booking could not be reserved:</p>
          <ul class="reservation-warning-list">
            ${data.items
                  .filter(item => item.status !== 'ok')
                  .map(item => `<li className="data-list-item">${message(item)}</li>`).join('')}
          </ul>
          <p>Please remove the item and add it again using an available time.</p>
        `)
}

export const prettyTableContent = (reservation, onclick) => {
  const table = document.createElement('table')
  table.innerHTML = `
                <table>
                  <thead>
                  <tr>              
                    <th style="min-width: 85px;">Remove</th>     
                    <th style="min-width: 100px;word-break: break-word;">Item</th>
                    <th style="min-width: 150px; width: 200px;">Message</th>
                    <th style="min-width: 50px;">Qty</th>
                    <th>Start</th>                                                          
                  </tr>
                  </thead>
                  <tbody>                    
                  </tbody>
                </table>`

  reservation.items.forEach(item => {
    const tr   = document.createElement('tr'),
          td   = document.createElement('td'),
          span = document.createElement('span')

    td.style.cssText = `min-width: 85px; text-align: center;`

    if (item.status !== 'ok') {
      span.innerHTML = trash
      span.onclick = () => onclick(item)
    }

    tr.innerHTML = `
        <td style="width: 100px;">${item.product_title}</td>
        <td style="text-transform: capitalize; width: 200px;">${prettyStatus(item)}</td>
        <th style="width: 50px;">${item.quantity}</td>
        <td><time className="reservation-date" dateTime="${item.start}">${moment.tz(item.start, reservation.tz).format(itemDateTimeFormat(item.all_day))}</time></td>`

    td.append(span)
    tr.prepend(td)
    table.querySelector('tbody').append(tr)
  })

  return table
}

export const itemDateTimeFormat = (all_day) => {
  if (all_day) {
    return `ll`;
  } else {
    return `ll ${timeFormat()} z`;
  }
}

export const parseDate = (date, format) => {
  if (!date) return false;

  if (date.length === 16) { // handle 'yyyy-mm-ddThh:mm'
    return date;
  } else {
    let parts        = date.split('/'),
        orderedParts = [];

    orderedParts.push(parts[2]);

    if (format === 'MM/DD/YYYY') {
      orderedParts.push(parts[0]);
      orderedParts.push(parts[1]);
    } else {
      orderedParts.push(parts[1]);
      orderedParts.push(parts[0]);
    }

    return orderedParts.join('-');
  }
}

/**
 * Convert a time string to iso format.
 */

export const parseTime = time => {
  if (!time) return false;

  let timeMoment = moment(time, ['h:m a', 'H:m']);
  return timeMoment.format('HH:mm');
}


